/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

const formatCoordinateValue = v => v.toFixed(5);

export default formatCoordinateValue;
